import {useTranslation} from 'react-i18next';
import {useField} from 'formik';
import {useSelector} from 'react-redux';
import InputList from '../../../../../component/input/inputList/InputList';
import * as css from './form.css';

function TriggerSelect() {
    const {t} = useTranslation('realtime');
    const [smtidsField, , smtidsHelper] = useField('smtids');
    const triggersList = useSelector((s: any) => s.realtime.systemMessage.triggers) ?? [];

    const triggersListOptions = triggersList.map(trigger => ({
        key: String(trigger.smtid),
        text: trigger.title,
    }));

    const onTriggerChanged = (name, itemKey) => {
        smtidsHelper.setTouched(true);
        if(itemKey === '0') {
            smtidsHelper.setValue(['0']);
        } else if(smtidsField.value?.includes('0')) {
            smtidsHelper.setValue([...smtidsField.value.filter(id => id !== '0'), itemKey]);
        }
    };

    const handleTriggerRemove = (smtid) => {
        smtidsHelper.setValue(smtidsField.value.filter(id => id !== smtid));
    };

    return (
        <css.roleSelectInput className='smtids'>
            <InputList 
                onChange={onTriggerChanged} 
                multiSelect={true} 
                name='smtids' 
                list={triggersListOptions} 
                text={t('triggers')} 
                isSelectable={true} 
                icon={undefined} 
                className={undefined} 
                valid={undefined} 
                onFocus={undefined}
            > </InputList>
            <css.rolesContainer>
                {smtidsField.value?.map(smtid => {
                    const trigger = triggersList.find(t => String(t.smtid) === smtid);
                    return trigger ? (
                        <css.triggerBtn key={smtid} onClick={() => handleTriggerRemove(smtid)}>
                            {trigger.title}
                        </css.triggerBtn>
                    ) : null;
                })}
            </css.rolesContainer>
        </css.roleSelectInput>
    );
}

export default TriggerSelect;

